const state = {
  autocompleteMixinShareCache: {
    SSearchStaffNew: null,
    SSearchStaffMutiNew: null
  }, // it is use as MAP... basic on the component's name
  autocompleteMixinIsLoading: {
    SSearchStaffNew: false,
    SSearchStaffMutiNew: false
  }, // it is use as MAP... basic on the component's name
  // decrypted: {
  //   fileKey: null // Random AES key generated from client side and use it to decrypte or encrypte documents.
  // },
  // encrypted: {
  //   fileKey: null // pass euid and this fileKey as array to API "/docflow/addDfDocumentOpener" for adding document openers
  // },
  security: {
    decryptedFileKey: null, // Random AES key generated from client side and use it to decrypte or encrypte documents.
    encryptedFileKey: null, // Random AES key generated from client side and it is encrypted by user's public key
    keyPairId: null // The id of key pair. If user forget password of key pair and reset it, key pair will be change also. Used to identify if user change the privateKey after he/she use the privateKey to encrypt file
  }
}

const mutations = {
  setAutocompleteMixinShareCache (state, { key, value }) {
    state.autocompleteMixinShareCache[key] = value
  },
  setAutocompleteMixinIsLoading (state, { key, value }) {
    state.autocompleteMixinIsLoading[key] = value
  },
  setDecryptedFileKey (state, fileKey) {
    state.security.decryptedFileKey = fileKey
  },
  // clearDecryptedFileKey (state) {
  //   state.security.decryptedFileKey = null
  // },
  setEncryptedFileKey (state, fileKey) {
    state.security.encryptedFileKey = fileKey
  },
  setKeyPairId (state, keyPairId) {
    state.security.keyPairId = keyPairId
  },
  // clearEncryptedFileKey (state) {
  //   state.security.encryptedFileKey = null
  //   state.security.keyPairId = null
  // },
  clearSecurityFileKeys (state) {
    state.security.decryptedFileKey = null
    state.security.encryptedFileKey = null
    state.security.keyPairId = null
  }
}

const getters = {
  decryptedFileKey (state) {
    return state.security.decryptedFileKey
  },
  encryptedFileKey (state) {
    return state.security.encryptedFileKey
  },
  keyPairId (state) {
    return state.security.keyPairId
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters
}
